/// <reference path='../../../../typings/index.d.ts' />
/// <reference path='controls.module.ts' />

module Meevo.Components.Controls {
    'use strict';

    export class MeevoTextArea implements angular.IDirective {
        private filter: angular.IFilterService;
        restrict = 'E';
        require = 'ngModel';
        scope = {
            name: '@',
            currentValue: '=ngModel',
            contentKey: '@',
            disabled: '=ngDisabled',
            ngReadonly: '=?',
            required: '=ngRequired',
            charLimit: '=?',
            autofocus: '=?',
            color: '=?',
            placeholder: '=',
            innerId: '@?',
            warningMessage: '=?',
            minimumAlphaCharacter: '=?',
            class: '@?',
            tabIndex: '=?',
            isModal: '=?',
            changed: "=?",
        };

        template = `
<div>
    <div class="meevo_input_wrapper">
        <label translate="{{::contentKey}}" ng-style="{'color': color}"></label>
        <div ng-class="{'ng-dirty required_red_bubble ': required && (!currentValue || !hasAlphaChar)}"></div>
    </div>
    <textarea   flex="100"
                ng-focus="autofocus" ng-class="{' red_border_invalid' : ((!currentValue || !hasAlphaChar) && required) }" class="{{class}}"
                ng-attr-style="{'color': color}" tabindex="{{tabIndex}}"
                name="{{name}}" maxlength="{{warningMessage ? '' : charLimit}}"
                ng-model="currentValue"
                id="{{ innerId }}"
                ng-attr-placeholder="{{ placeholder }}"
                ng-disabled="disabled" ng-required="required"
                ng-readonly="ngReadonly"
                is-modal="isModal"
                ng-trim="false"
                ng-change="onChange()"
    ></textarea>
    <span layout="row" layout-align="end center" class="characterLimit" ng-if="charLimit">{{ countLeft }} Characters Left</span>
</div>
<div ng-if="warningMessage && countLeft <= 0">
    <div translate="HEADER_WARNING"></div>
    <div translate="LABEL_YOU_HAVE_MET_CHARACTER_LIMIT"></div>
</div>`;

        constructor(private $compile: angular.ICompileService) {

        }

        link = (scope: any, element: JQuery, attrs: angular.IAttributes, ngModel) => {
            let ele = angular.element(element).find('textarea');
            scope.hasAlphaChar = false;
            if (scope.autofocus) {
                let timeoutLength = scope.isModal ? 750 : 500;
                window.setTimeout(function () {
                    console.log(ele);
                    ele.focus(0);
                }, timeoutLength);
            }

            if (typeof scope.color === 'undefined') {
                scope.color = 'black';
            }
            if (typeof scope.ngReadonly === 'undefined') {
                scope.ngReadonly = false;
            }
            if (typeof scope.innerId === 'undefined') {
                scope.innerId = '';
            }
            if (!scope.charLimit) {
                scope.charLimit = '';
            }

            if (scope.currentValue) {
                scope.countLeft = scope.charLimit - scope.currentValue.length;
            } else {
                scope.countLeft = scope.charLimit;
            }

            if (scope.minimumAlphaCharacter) {
                ngModel.$validators.alphachar = (modelValue, viewValue) => {
                    scope.hasAlphaChar = (modelValue != null && modelValue.match(/[A-Za-z]/g) != null && modelValue.match(/[A-Za-z]/g).length >= scope.minimumAlphaCharacter);
                    return scope.hasAlphaChar;
                };
            } else {
                scope.hasAlphaChar = true;
            }

            scope.$watch(() => scope.currentValue,
                function (currentValue, prevValue) {
                    if (typeof currentValue === 'undefined') {
                        if (typeof prevValue !== 'undefined') {
                            scope.currentValue = "";
                        }
                    } else {
                        scope.countLeft = scope.charLimit - currentValue.length;
                    }
                });
            element.on('click', (event: JQueryEventObject) => {
                if (!scope.isDisabled) {
                    let target: any = event.target || event.srcElement;
                    if (target.id === scope.id) {
                        target.select();
                    }
                    event.preventDefault();
                }
            });

            scope.onChange = () => {
                if (scope.changed) {
                    scope.$eval(scope.changed);
                }
            }
        };

        static factory(): angular.IDirectiveFactory {
            let directive = ($compile) => {
                return new MeevoTextArea($compile);
            };

            directive.$inject = ['$compile'];

            return directive;
        }
    }

    angular.module('meevo.components.controls')
        .directive('meevoTextArea', MeevoTextArea.factory());
}